<script>
  import { dev } from "$app/environment";
  import { reconcilePushOwner } from "/common/pwa";
  import { onMount } from "svelte";
  import { goto } from "$app/navigation";
  import { page } from "$app/state";
  let { children } = $props();
  import { isAuthenticated, loadConfig } from "/stores";
  import { user } from "/stores";
  import GnbAdmin from "/components/GNB-Admin.svelte";
  import GnbPartner from "/components/GNB-Partner.svelte";
  import GnbPartnerMobile from "/components/GNB-PartnerMobile.svelte";
  import FavoriteMenuBar from "/components/FavoriteMenuBar.svelte";
  import Toast from "/components/Toast.svelte";
  import AlertModal from "/components/AlertModal.svelte";
  import ConfirmModal from "/components/ConfirmModal.svelte";
  import HelpWindow from "/components/HelpWindow.svelte";

  onMount(() => {
    loadConfig();
    const unsubscribe = user.subscribe(() => {
      if (!dev) queueMicrotask(() => { void reconcilePushOwner().catch(() => {}); });
    });
    return unsubscribe;
  });

  const exceptedGNBPaths = ["/partner/as/sign", "/external-auth", "/invoice-print", "/sales-print", "/penalty-print", "/ledger-print", "/usage-print", "/partner-usage-print", "/fbkr-statement-print", "/partneron-statement-print", "/as/intake"];
  // 인증 가드 제외 경로 (공개 페이지 + 비로그인 진입 페이지)
  const publicPaths = ["/", "/register", "/reset-password", "/external-auth", "/invoice-print", "/sales-print", "/penalty-print", "/ledger-print", "/usage-print", "/partner-usage-print", "/fbkr-statement-print", "/partneron-statement-print", "/partner/as/sign", "/as/intake"];

  // GNB 제외 경로 확인 (반응형)
  let isExceptedGNB = $derived(page.url.pathname === '/pricing' || exceptedGNBPaths.some((e) => page.url.pathname.includes(e)));

  // 모바일 경로 확인
  let isMobilePath = $derived(page.url.pathname.startsWith('/mobile/'));
  let hasDesktopSidebar = $derived($isAuthenticated && !isExceptedGNB && !isMobilePath);

  // 기존 공개 경로와 사용자 유형별 접근 정책을 유지한다. API 권한은 Go에서 검증한다.
  let isPublic = $derived(page.url.pathname === '/pricing' || publicPaths.some(p => p === '/' ? page.url.pathname === '/' : page.url.pathname.startsWith(p)));
  let allowed = $derived(isPublic || ($isAuthenticated &&
    !(page.url.pathname.startsWith('/admin') && $user.Type !== 'admin') &&
    !((page.url.pathname.startsWith('/partner') || page.url.pathname.startsWith('/mobile/partner')) && $user.Type === 'admin')));
  $effect(() => {
    if (!allowed) void goto('/', { replaceState: true });
  });
</script>

{#if !isExceptedGNB}
  <header>
    {#if $isAuthenticated}
      {#if isMobilePath}
        <!-- 모바일 GNB -->
        <GnbPartnerMobile />
      {:else if $user.Type === "admin"}
        <!-- 데스크톱 Admin GNB -->
        <GnbAdmin />
      {:else}
        <!-- 데스크톱 Partner GNB -->
        <GnbPartner />
      {/if}
    {/if}
  </header>
{/if}

{#if allowed}
  <div class:desktop-shell={hasDesktopSidebar} style:display={hasDesktopSidebar ? 'block' : 'contents'}>
  {#if hasDesktopSidebar && $user.Type !== "admin"}
    <FavoriteMenuBar />
  {/if}
  <!-- 기존 라우터처럼 경로/쿼리 변경 시 페이지의 onMount와 필터를 초기화한다. -->
  {#key page.url.pathname + page.url.search}
    {@render children()}
  {/key}
  </div>
{/if}
<Toast />
<AlertModal />
<ConfirmModal />
<HelpWindow />
